<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-office-building`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.154 46C6.964 46 6 45.015 6 43.8V4.2C6 2.985 6.964 2 8.154 2h23.692C33.036 2 34 2.985 34 4.2V10h6a2 2 0 012 2v32a2 2 0 01-2 2H8.154zM30 6H10v36h6v-7a1 1 0 011-1h6a1 1 0 011 1v7h6V6zm8 8h-4v28h4V14zm-20 8v4h-4v-4h4zm8 0v4h-4v-4h4zm-8-8v4h-4v-4h4zm8 0v4h-4v-4h4z"/></svg>
</template>
<script>

export default {
  name: 'IconOfficeBuilding',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
